import axios from 'axios';
import { BRAND_BASE_URL } from '../BaseURL';
import getHeaders from '../../constants/headers';

export const getLedgerMode = () => {
  return axios({
    method: 'get',
    url: BRAND_BASE_URL + '/store/api/secure/v1/ledger-mode',
    headers: getHeaders(),
  });
};

export const getLedgerInfo = (storeCustomerId, storeId, data) => {
  return axios({
    method: 'post',
    url:
      BRAND_BASE_URL +
      '/store/api/secure/v1/store/' +
      storeId +
      '/store-customer/' +
      storeCustomerId +
      '/ledger', // for android use
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};

export const getLedgerInfoV2 = (storeCustomerId, storeId, data) => {
  return axios({
    method: 'post',
    url:
      BRAND_BASE_URL +
      '/store/api/secure/v2/store/' +
      storeId +
      '/store-customer/' +
      storeCustomerId +
      '/ledger', // for android use
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};